function startStopwatch(stopwatchElement) {
  const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
  const dia = parseInt(stopwatchElement.getAttribute('data-day'));
  const mes = parseInt(stopwatchElement.getAttribute('data-month'));
  const ano = parseInt(stopwatchElement.getAttribute('data-year'));

  if (isNaN(hora) || isNaN(dia) || isNaN(mes) || isNaN(ano)) return;

  const cronometroEl = stopwatchElement.querySelector('#cronometro');
  if (!cronometroEl) return;

  function formatarDigitos(numero) {
    const n = numero.toString().padStart(2, '0');
    return `<span>${n[0]}</span><span>${n[1]}</span>`;
  }

  const dataTermino = new Date(ano, mes - 1, dia, hora, 0);

  function atualizar() {
    const tempoRestante = dataTermino.getTime() - new Date().getTime();
    if (tempoRestante >= 0) {
      const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
      const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);
      cronometroEl.innerHTML = `<div>${formatarDigitos(dias)}d ${formatarDigitos(horas)}h ${formatarDigitos(minutos)}m ${formatarDigitos(segundos)}s</div>`;
    } else {
      cronometroEl.innerHTML = 'Tempo esgotado!';
      clearInterval(intervalo);
    }
  }

  const intervalo = setInterval(atualizar, 1000);
  atualizar();
}

document.addEventListener('DOMContentLoaded', function () {
  const stopwatchElement = document.querySelector('.stopwatch');

  if (stopwatchElement) {
    // Páginas com stopwatch renderizado diretamente (categoria, detalhe)
    startStopwatch(stopwatchElement);
  } else {
    // Home: stopwatch está dentro de seção lazy-loaded — aguarda via MutationObserver
    const observer = new MutationObserver(function () {
      const el = document.querySelector('.stopwatch');
      if (el) {
        observer.disconnect();
        startStopwatch(el);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      useFirst: true, // first headerBar
      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
      isNavUp: true,
      isNavDown: true,
      isNavMin: false,
      lastScrollTop: 0,
      menuMobile: false,
      openCategorysMobile: false,
    },
    searchOpened: false,
    cartOpened: false,
  },
  methods: {
    addPaddingHeader() {
      const headerTransparent = document.querySelector('.nav-up');
      const header = document.querySelector('header[data-role="heading"]');
      const headerHeight = header.clientHeight;
      const mainTag = document.querySelector('main[role="main"]');
      const mainDiv = document.querySelector('.main-content');
      const bread = document.querySelector('.breadcrumb')

      if (headerTransparent) {
        if (view_origin != "home") {
          if (mainTag) {
            mainTag.setAttribute("style", `padding-top:${headerHeight}px !important`);
          } else if (mainDiv && bread) {
            if ($(bread).css('display') == 'none') {
              mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
              bread.setAttribute("style", `margin-top:0px !important`);
            } else {
              mainDiv.setAttribute("style", `padding-top:0px !important`)
              bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
            }
          } else if (mainDiv) {
            mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
          } else if (bread) {
            bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
          }
        }
      } else {
        if (mainTag) {
          mainTag.setAttribute("style", `padding-top:${headerHeight}px !important`);
        } else if (mainDiv && bread) {
          if ($(bread).css('display') == 'none') {
            mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
            bread.setAttribute("style", `margin-top:0px !important`);
          } else {
            mainDiv.setAttribute("style", `padding-top:0px !important`)
            bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
          }
        } else if (mainDiv) {
          mainDiv.setAttribute("style", `padding-top:${headerHeight}px !important`)
        } else if (bread) {
          bread.setAttribute("style", `margin-top:${headerHeight}px !important`);
        }
      }
    },
    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.search__submit').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },
    scrollFixedMenu() {
      const menuFixed = document.querySelector('.menu-fixed');
      if (menuFixed) {
        let lastScrollTop = 0;
        menuFixed.classList.remove('active');

        window.addEventListener('scroll', function () {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > lastScrollTop) {
            // Scrolling down
            menuFixed.classList.add('active');
          } else {
            // Scrolling up
            menuFixed.classList.remove('active');
          }

          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For mobile or negative scrolling
        });
      }
    },
    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollDifference = st - this.lastScrollTop;
      const customMobile = document.getElementById('custom-mobile-nav');
      const headerThird = document.getElementById('header-third');
      const quickMenu = document.getElementById('quick-menu-id');
      const whatsappWidget = document.getElementById('widget-whatsapp');

      if (st > this.lastScrollTop)
        this.header.isNavUp = false;
      else {
        if (st === 0)
          this.header.isNavUp = true;
      }

      if (st >= 90 && scrollDifference > 0) {
        this.header.isNavDown = false;
        this.header.isNavMin = true;

        if (customMobile)
          customMobile.classList.add('hide');

        if (headerThird)
          headerThird.classList.add('hide');

        if (quickMenu) {
          quickMenu.classList.add('hide');
          whatsappWidget.style.bottom = '';
        }

      } else {
        this.header.isNavDown = true;
        this.header.isNavMin = false;
        this.header.isNavMenuHide = false;

        if (customMobile)
          customMobile.classList.remove('hide');

        if (headerThird)
          headerThird.classList.remove('hide');

        if (quickMenu) {
          quickMenu.classList.remove('hide');
          whatsappWidget.style.bottom = '79px';
        }
      }

      this.lastScrollTop = st;
    },
    filterItems(item1, item2, item3, item4) {
      var data = [item1, item2, item3, item4];

      for (var i = 0; i < data.length; i++) {
        var element = document.querySelector('[item="' + data[i] + '"]');
        switch (data[i]) {
          case "home":
            element.setAttribute('href', '/');
            break;
          case "menu":
            var newSpan = document.createElement('span');
            newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

            while (element.firstChild) {
              newSpan.appendChild(element.firstChild);
            }

            element.parentNode.replaceChild(newSpan, element);
            break;
          case "cart":
            element.setAttribute('href', '/carrinho');
            break;
          case "user":
            element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
            break;
          case "wishlist":
            element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
            break;
        }
      }
    }
  },
  mounted() {
    $('#js-texto-header').slick({
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      mobileFirst: true,
    });

    this.addPaddingHeader();
    this.scrollFixedMenu();

    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
});

const openSearch = document.querySelector('.open-search .open-search-icon');
if (openSearch) {
  openSearch.addEventListener('click', () => {
    // O .search do header fica DENTRO do .open-search (desktop) ou como filho
    // direto do #app_header (mobile). Selecionamos assim de propósito para NÃO
    // pegar o outro .search que o menu mobile (.mobile-nav) também renderiza
    // pelo mesmo new_search.html — que aparece antes no DOM e roubava o active.
    const search = openSearch.closest('.open-search').querySelector('.search')
      || document.querySelector('#app_header > .search');
    if (!search) return;

    openSearch.classList.toggle('active');
    const isActive = search.classList.toggle('active');
    // Se o search está sendo ativado, procura o input e dá focus
    if (isActive) {
      const searchInput = search.querySelector('input[type="search"], input[type="text"], .search__text');
      if (searchInput) {
        // focus() síncrono (dentro do gesto do clique) para o teclado do mobile
        // subir; preventScroll evita o "pulo" da página, já que o .search é
        // position: absolute dentro do header fixo.
        searchInput.focus({ preventScroll: true });
      }
    }
  });
}

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

const mobileNavReturns = document.querySelectorAll('.js-mobile-nav-return.mobile-nav__item--return');

mobileNavReturns.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    const mobileItem = this.closest('.mobile-nav__item');
    if (mobileItem) {
      const mobileLink = mobileItem.querySelector('.mobile-nav__link.ewrap');
      if (mobileLink) {
        mobileLink.classList.toggle('active');
      }
      const wrapper = mobileItem.querySelector('.mobile-nav__wrapper');
      if (wrapper && wrapper.tagName === 'UL') {
        wrapper.classList.toggle('active');
      }
    }
  });
});

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-header__close, .cart-preview--overlay, .cart-preview .btn-continue, .header__second--tools-cart-preview');

cart_preview_triggers.on("click", function (e) {
  document.body.classList.toggle('no-scroll');
  document.documentElement.classList.toggle('no-scroll');
  $('.cart-preview').toggleClass('active');
  $('.cart-preview--overlay').toggleClass('active');
});